let reloadTable = function() {
	this.paginador = 0;
	this.statuslist = [1, 2, 3, 4, 5];
	this.getMethods();
	this.searchFilter();
	// this.getInvoices();
};
export default reloadTable;
